import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-slim-reservation-info',
  templateUrl: './slim-reservation-info.component.html',
  styleUrls: ['./slim-reservation-info.component.scss']
})
export class SlimReservationInfoComponent implements OnInit {
  @Input() reservation:any;
  constructor() { }

  ngOnInit() {
  }

}
